"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESPONSIVE_DIALOG_DRAWER_TITLE = exports.RESPONSIVE_DIALOG_DRAWER_HEADER = exports.RESPONSIVE_DIALOG_DRAWER_FOOTER = exports.RESPONSIVE_DIALOG_DRAWER_CONTENT = exports.RESPONSIVE_DIALOG_DRAWER_CLOSE_BUTTON = exports.RESPONSIVE_DIALOG_DRAWER = void 0;
const RESPONSIVE_DIALOG_DRAWER = exports.RESPONSIVE_DIALOG_DRAWER = 'responsive-dialog-drawer';
const RESPONSIVE_DIALOG_DRAWER_CLOSE_BUTTON = exports.RESPONSIVE_DIALOG_DRAWER_CLOSE_BUTTON = 'responsive-dialog-drawer-close-button';
const RESPONSIVE_DIALOG_DRAWER_HEADER = exports.RESPONSIVE_DIALOG_DRAWER_HEADER = 'responsive-dialog-drawer-header';
const RESPONSIVE_DIALOG_DRAWER_CONTENT = exports.RESPONSIVE_DIALOG_DRAWER_CONTENT = 'responsive-dialog-drawer-content';
const RESPONSIVE_DIALOG_DRAWER_FOOTER = exports.RESPONSIVE_DIALOG_DRAWER_FOOTER = 'responsive-dialog-drawer-footer';
const RESPONSIVE_DIALOG_DRAWER_TITLE = exports.RESPONSIVE_DIALOG_DRAWER_TITLE = 'responsive-dialog-drawer-title';
